import { Skeleton } from '../../../Skeleton';

import styles from './Skeletons.module.scss';

export const ActionsSkeleton = () => <Skeleton type="rectangle" className={styles.actionsSkeleton} />;
